import { getPanelTop } from 'weblite-router'
import {
  getRoom,
  getRoomPermissions,
  isClientsRoom,
  RoomPermission,
  storageByRoomType,
} from '$logic/room'
import { setSubscriptionUnreadMark } from '$logic/subscription'
import { getPv, setPvUnreadMark } from '$logic/pv'
import { fetchUserStatus } from '$logic/users'
import { openRoomPage } from '$logic/router'
import { setPrivateSpaceUnreadMark } from '$logic/private-space'
import { setWappRoomUnreadMark } from '$logic/wapp-room'
import { openedRoomMessagesStorage } from '$logic/opened-room/opened-room-messages.storage'
import { initiateRoomPinMessages, removeRoomPinsSync } from '$logic/pin'
import { initiateRoomMessage } from './opened-room-messages.service'

export async function onOpenRoom(roomId: string, openingIid?: number) {
  removeRoomPinsSync()
  //  NOTE: load Messages
  await initiateRoomMessage(openingIid)
  initiateRoomPinMessages(roomId)

  const room = await getRoom(roomId)
  if (!room) return

  if (room.type === 'PV') {
    //  NOTE: If room is PV, send request for user status
    const pv = await getPv(roomId)
    fetchUserStatus(pv?.to)
    setPvUnreadMark(roomId, false)
  } else if (room.type === 'WAPP_ROOM') setWappRoomUnreadMark(roomId, false)
  else if (room.type === 'PRIVATE_SPACE') setPrivateSpaceUnreadMark(false)
  else if (['GROUP', 'CHANNEL'].includes(room.type)) {
    // ignore if public hall
    if (isClientsRoom(roomId)) setSubscriptionUnreadMark(roomId, false)
  }
}

export async function openRoom(roomId: string, openingIid?: number) {
  const openedRoomId = getOpenedRoomId()

  const room = await getRoom(roomId)
  if (!room || (roomId === openedRoomId && !openingIid)) return

  openedRoomMessagesStorage.deleteAll()
  openRoomPage(roomId)
  await onOpenRoom(roomId, openingIid)
}

export function getOpenedRoomId() {
  return getPanelTop('room')?.state?.roomId || null
}

export function getOpenedRoom() {
  const roomId = getOpenedRoomId()
  if (roomId) return getRoom(roomId)
  return null
}

export async function getOpenedRoomData() {
  const room = await getOpenedRoom()
  if (!room) return null
  const { get } = storageByRoomType(room.type)
  return get(room.id)
}

export async function openedRoomPermissions(): Promise<RoomPermission> {
  const roomId = getOpenedRoomId()
  return getRoomPermissions(roomId)
}
